__turbopack_context__.v({
  "active": "styles-module__zI3dnq__active",
  "colorInput": "styles-module__zI3dnq__colorInput",
  "colorPopup": "styles-module__zI3dnq__colorPopup",
  "customizer": "styles-module__zI3dnq__customizer",
  "customizerBody": "styles-module__zI3dnq__customizerBody",
  "customizerSubtitle": "styles-module__zI3dnq__customizerSubtitle",
  "customizerTitle": "styles-module__zI3dnq__customizerTitle",
  "dotStyles": "styles-module__zI3dnq__dotStyles",
  "header": "styles-module__zI3dnq__header",
  "hr": "styles-module__zI3dnq__hr",
  "itemLabel": "styles-module__zI3dnq__itemLabel",
  "itemWrapper": "styles-module__zI3dnq__itemWrapper",
  "modeWrapper": "styles-module__zI3dnq__modeWrapper",
  "primaryColor": "styles-module__zI3dnq__primaryColor",
  "primaryColorWrapper": "styles-module__zI3dnq__primaryColorWrapper",
  "show": "styles-module__zI3dnq__show",
  "smallScreen": "styles-module__zI3dnq__smallScreen",
  "toggler": "styles-module__zI3dnq__toggler",
});
